import { PRIVATE_SIGNIN_REFRESH_SESSION } from 'global/private-routes.constants';

export const isOnSignInRefreshSessionPage = () => {
  return window.location.pathname.includes(PRIVATE_SIGNIN_REFRESH_SESSION);
};
